module.exports = __webpack_public_path__ + "img/login-bg-9.c5c59849.jpg";